"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZIP_CODES_UPLOAD_DONE = exports.NEW_EMPLOYEE = exports.DELETE_EMPLOYEE = exports.NEW_TASK = exports.TASK_DELETED = exports.NEW_NOTE = exports.NEW_SCAN = exports.WAYPOINT_UPDATED = exports.WAYPOINT_DELETED = exports.WAYPOINT_ADDED = exports.TASK_UPDATE = exports.MERCHANT_SUBSCRIPTION_UPDATE = exports.MERCHANT_UPDATE = exports.USER_CONNECT_SUCCESS_EVENT = exports.SUBSCRIBE_AS_ADMIN_EVENT = exports.EMPLOYEE_UPDATE_EVENT = exports.USER_CONNECT_EVENT = exports.PubSubEvent = void 0;
var PubSubEvent = /** @class */ (function () {
    function PubSubEvent(name) {
        this.name = name;
    }
    return PubSubEvent;
}());
exports.PubSubEvent = PubSubEvent;
exports.USER_CONNECT_EVENT = new PubSubEvent('user connect');
exports.EMPLOYEE_UPDATE_EVENT = new PubSubEvent('employee update');
exports.SUBSCRIBE_AS_ADMIN_EVENT = new PubSubEvent('subscribe as admin');
exports.USER_CONNECT_SUCCESS_EVENT = new PubSubEvent('connect success');
exports.MERCHANT_UPDATE = new PubSubEvent('merchant update');
exports.MERCHANT_SUBSCRIPTION_UPDATE = new PubSubEvent('merchant subscription updated');
exports.TASK_UPDATE = new PubSubEvent('task update');
exports.WAYPOINT_ADDED = new PubSubEvent('waypoint added');
exports.WAYPOINT_DELETED = new PubSubEvent('waypoint deleted');
exports.WAYPOINT_UPDATED = new PubSubEvent('waypoint updated');
exports.NEW_SCAN = new PubSubEvent('new scan');
exports.NEW_NOTE = new PubSubEvent('new note');
exports.TASK_DELETED = new PubSubEvent('task deleted');
exports.NEW_TASK = new PubSubEvent('new task');
exports.DELETE_EMPLOYEE = new PubSubEvent('delete employee');
exports.NEW_EMPLOYEE = new PubSubEvent('new employee');
exports.ZIP_CODES_UPLOAD_DONE = new PubSubEvent('team zip codes import done');
//# sourceMappingURL=PubSubEvents.js.map